// -*-mode: rjsx -*-
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles, withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
//import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"
import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import InfoIcon from '@material-ui/icons/InfoOutlined'
import DescriptionIcon from '@material-ui/icons/Description'

import AppContext from "../../..//AppContext.js"

// BL
import {
    // eslint-disable-next-line    
    maxNumberReducer,
    // eslint-disable-next-line    
    minNumberReducer,
    fieldFilter
} from "../../../bl/A/bl"

// D3
import * as d3 from "d3" 

// UTILS
import * as _ from "lodash"


// LOGGING SETUP
import appConfig from "./../../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<DashMapV5>")

const useStyles = makeStyles(theme => ({

    root: {
        //        background: "black",
        width: "100%",
        height: "100%",
        marginTop: theme.spacing(2),
    },
    
    paper: {
        width: '100%',
        height: '100%',
        borderRadius: "8px",
        minHeight: 300,
        maxHeight: 500,
        marginBottom: theme.spacing(2),
    },
    
    chartDiv: {
        // backgroundColor: "#eae6e6",
        // position: "relative",
        // padding: 5,
        paddingBottom: "90px",
        width: "100%",
        height: "100%",
        
        display: "flex",
        flexDirection: "column",
        // alignItems: "center",
        alignItems: "left", // left right
        justifyContent: "center",
    },

    chartSvg: {
        //        backgroundColor: "#f5f5f5",
        width: "100%",
        height: "100%",
        //        width: "500px",
        //        height: "500px",
    },

    /*
      uscd: {
      fill: "#448cff",
      stroke: "black",
      strokeWidth: 2
      },
    */

    tooltipDiv: {   
 	position: "absolute",
        textAlign: "left",
 	borderRadius: "5px",
        padding: "0.6em 1em",
        background: "#fff",
        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
        transition: "all 0.2s ease-out",
        pointerEvents: "none",
        zIndex: 10,
        opacity: 0
    },

    tooltipItemName: {
        // fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "15px",
        //fontWeight: "600",
        marginRight: "10px",
        // color: "#00000099"
        //        color: "#000000",
        color: "#65676b"        
    },


    noDataText: {
        // fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        //fontWeight: "600",
        marginLeft: "16px",
        // color: "#00000099"
        //        color: "#000000",
        color: "#65676b"        
    },



    
    tooltipItemVal: {
        //fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "17px",
        //fontWeight: 600,
        // color: "#65676b"
        // color: "#00000099",
        color: "#000000",
        //color: "#65676b"        
    },


    loadingMessage: {
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "15px",
        color: "#65676b"
    }
}))

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        marginTop: "5px",
        marginLeft: "3px",
        // height: "200px",
        //maxWidth: 220,
        width: "310px",
        // backgroundColor: '#f5f5f9',
        backgroundColor: "white",
        //color: 'rgba(0, 0, 0, 0.87)',
        color: "black",
        borderRadius: "8px",
        //        boxShadow: "0 12px 28px 0 var(--shadow-2),0 2px 4px 0 var(--shadow-1),inset 0 0 0 1px var(--shadow-inset)",
         //        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
        //boxShadow: "0 12px 28px rgba(52, 73, 94, .2), 0 12px 28px rgba(52, 73, 94, 0.1)",

        // first is the "big one" allaround
        // second is a little bit on the inside
        // inset is what's inside the box that defines the "border"
        // boxShadow: "0 12px 28px 0 red, 0 2px 4px 0 green, inset 0 0 0 1px yellow ",

        // below works, but with no shadown for arrow at the top
//        boxShadow: "0 12px 28px 0 rgba(52, 73, 94, .2), 0 2px 4px 0 rgba(52, 73, 94, .2), inset 0 0 0 1px rgba(52, 73, 94, .2) ",

        boxShadow: "0 12px 28px 0 rgba(52, 73, 94, .2), 0 2px 4px 0 rgba(52, 73, 94, .2), inset 0 0 0 1px rgba(52, 73, 94, .2) ",


        // actual insides
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: theme.typography.pxToRem(12),
        paddingBottom: "8px",
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "8px",
        
//        border: '1px solid #dadde9',
        // from the other
// 	borderRadius: "5px",
//        left: "0",
//        padding: "0.6em 1em",
//        background: "#fff",
        //   background: "red",
//        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
//        transition: "all 0.2s ease-out",
//        pointerEvents: "none",
//        zIndex: 100
        
    },
    tooltipPlacementLeft: {
        // margin: "250px 100px",
        //marginTop: "250px",
        //marginLeft: "400px",
    },
    arrow: {
        color: "white",
        width: "12px",
        height: "12px",
        // border: "1px solid #ddd",
        //        transform: "translate(-50%, 50%) rotate(45deg)!important",
        //transform: "rotate(45deg)!important",
        // border: "1px solid #dadde9",
//        boxShadow: "0 12px 28px 0 rgba(52, 73, 94, .2), 0 2px 4px 0 rgba(52, 73, 94, .2), inset 0 0 0 1px rgba(52, 73, 94, .2) ",
        // border-bottom-color:rgba(0, 0, 0, 0);
        //border-bottom-style:solid;
        //border-bottom-width:6px;
        
    },
//[x-placement*="bottom"]

    /*
    'popperArrow[x-placement*="bottom"]': {
        "& .MuiTooltip-arrow": {
            top: "0",
            left: "0",
            //            marginTop: "-0.71em",
            // marginTop: "0!important",            yeah, it works
            marginTop: "0",
            marginLeft: "4px",
            marginRight: "4px"
        }
    }*/

    // yes, this works!!!
    popperArrow: {
        '&[x-placement*="bottom"] .MuiTooltip-arrow': {
            top: "0",
            left: "0",
            //            marginTop: "-0.71em",
            // marginTop: "0!important",            yeah, it works
            marginTop: "-10px",
            marginLeft: "15px",
            marginRight: "12px",
            width: "16px",
        }
    }

}))(Tooltip)


const useToolbarStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
    theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
    : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
    },
    header1: {
        // flex: '1 1 100%',
        // backgroundColor: "grey"
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "17px",
        fontWeight: "600",
    },

    header2: {
        // flex: '1 1 100%',
        // backgroundColor: "black"
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "15px",
        color: "#65676b"
    },

    headersWrapper: {
        flex: '1 1 100%'
    },

    infoIconRoot: {
        fontSize: "27px"
    },

    
}));


function EnhancedTableToolbar(props) {
    const classes = useToolbarStyles();
    const { numSelected, header1, header2 } = props;

    const [infoOpen, setInfoOpen] = React.useState(false)

    const handleInfoTooltipClose = () => {
        log.debug("handleInfoTooltipClose()")
        //onInfoClosed()
        setInfoOpen(false);
    }

    const handleInfoTooltipOpen = () => {
        log.trace("handleInfoTooltipOpen()")
        
        if(infoOpen) {
            //onInfoClosed()
            setInfoOpen(false)
        } else {
            // onInfoOpen()
            setInfoOpen(true)
        }
    }
    
    log.trace("EnhancedTableToolbar(): body: props =", props)
    
    return (
        <Toolbar
          className={clsx(classes.root, {
              [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
              <Typography className={classes.title} color="inherit" variant="subtitle1">
                {numSelected} selected
              </Typography>
          ) : (
              <div className={classes.headersWrapper}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                }}>
                <Typography className={classes.header1} variant="h6" id="tableHeader1">
                  {header1}
                </Typography>

              <ClickAwayListener onClickAway={handleInfoTooltipClose}>
                <div>
                  <HtmlTooltip id="infoTooltip"
                               PopperProps={{
                                   disablePortal: false,
                                   strategy: "fixed",
                                   placement: "bottom-end",
                                   modifiers: 
                                       {
                                           flip: {
                                               // behavior: ['left', 'right', 'top','bottom']
                                               // behavior: ['top']
                                               enabled: false // yes, this works!, need to be using 1.x
                                           },
                                           arrow: {
                                           }
                                       },

                               }}
                               arrow // yes, this works, but make it like we have for the chart tooltip
                               // onClose={handleInfoTooltipClose}
                               open={infoOpen}
                               //disableFocusListener
                               //disableHoverListener
                               //disableTouchListener
                               interactive
                               //disableReactTree={true}
                               title={
                                   <React.Fragment>
                                     <div id="infoDiv">
                                       <div style={{
                                           display: "flex",
                                           justifyContent: "center",
                                           alignItems: "center",
                                           verticalAlign: "center",
                                           height: "56px",
                                           fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
                                           borderBottomColor: "#65676b4d",
                                           borderBottomStyle: "solid",
                                           borderBottomWidth: "1px"
                                       }}>
                                         <span id="infoHeader1Text" style={{
                                             marginTop: "-4px",
                                             marginBottom: "-5px",
                                         }}><Typography style={{
                                             fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                             fontSize: "20px",
                                             fontWeight: 700,
                                             lineHeight: "24px",
                                         }}>About This Map</Typography></span>
                                       </div>

                                       <div id="infoSectionWrapper" style={{
                                           display: "flex",
                                           alignItems: "flex-start",
                                           paddingBottom: "16px",
                                           paddingTop: "14px",
                                           fontSize: "12px"
                                       }}>
                                         <DescriptionIcon style={{
                                             marginRight: "6px",
                                             fontSize: "12px",
                                             verticalAlign: "-3px",
                                             height: "24px",
                                             width: "24px"
                                         }}/>
                                         <div style={{
                                             display: "flex",
                                             flexDirection: "column",
                                             fontSize: "12px",
                                         }}>
                                           <div style={{
                                               fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
                                               fontSize: "15px",
                                               fontWeight: 600,
                                               marginBottom: "4px",
                                               marginTop: "-1px"
                                           }}>Interactive Map</div>

                                           <div style={{
                                               fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                               fontSize: "13px",
                                               fontWeight: 400,
                                               // marginBottom: "-4px",
                                               // marginTop: "-1px",
                                               overflowWrap: "break-word",
                                               textAlign: "left",
                                               wordBreak: "break-word",
                                               color: "#65676b"
                                           }}>All maps are interactive. They provide activity data and link to state and district maps. <b><em>{"Hover over"}</em></b> the <b>region</b> to see activity. <b><em>{"Click on"}</em></b> the <b>region</b> to go to that region.</div>
                                         </div>
                                       </div> {/* end section wrapper */}


                                       <div id="infoSectionWrapper" style={{
                                           display: "flex",
                                           alignItems: "flex-start",
                                           paddingBottom: "16px",
                                           paddingTop: "14px",
                                           fontSize: "12px"
                                       }}>
                                         <DescriptionIcon style={{
                                             marginRight: "6px",
                                             fontSize: "12px",
                                             verticalAlign: "-3px",
                                             height: "24px",
                                             width: "24px"
                                         }}/>
                                         <div style={{
                                             display: "flex",
                                             flexDirection: "column",
                                             fontSize: "12px",
                                         }}>
                                           <div style={{
                                               fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
                                               fontSize: "15px",
                                               fontWeight: 600,
                                               marginBottom: "4px",
                                               marginTop: "-1px"
                                           }}>Regions</div>

                                           <div style={{
                                               fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                               fontSize: "13px",
                                               fontWeight: 400,
                                               // marginBottom: "-4px",
                                               // marginTop: "-1px",
                                               overflowWrap: "break-word",
                                               textAlign: "left",
                                               wordBreak: "break-word",
                                               color: "#65676b"
                                           }}>
                                             Regions are <b><em style={{color: "#a2c3f8"}}>{"light blue"}</em></b> or <b><em style={{color: "#448cff"}}>{"deeper blue"}</em></b> to reflect general level of activity.{" "}
                                           </div>
                                         </div>
                                       </div> {/* end section wrapper */}

                                       
                                       {/*
                                      <Typography style={{fontSize: "14px"}} color="inherit"></Typography>
                                       Brought <em>{"to you"}</em> by <span style={{color: "blue"}}>{'Lightning'}</span> <u>{'with love'}</u>.{' '}
                                       {" "}<br/><br/>
                                        */}
                                     </div>
                                   </React.Fragment>
                               }>
                    <IconButton aria-label="info" onClick={handleInfoTooltipOpen}
                                style={{
                                    padding: "0px",
                                    paddingLeft: "8px"
                                }}>
                      <InfoIcon classes={{root: classes.infoIconRoot}}
                                style={{fontSize: "25px"}}
                      />
                    </IconButton>
                  </HtmlTooltip>
                </div>
              </ClickAwayListener>


                </div>




                
                <Typography className={classes.header2} variant="h6" id="tableHeader2">
                  {header2}
                </Typography>
              </div>
          )}

          {numSelected > 0 ? (
              <Tooltip title="Delete">
                <IconButton aria-label="delete">
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
          ) : (<span>
                 <IconButton aria-label="Geo Filter" onClick={props.onFilterClick}>
                   <FilterListIcon />
                 </IconButton>
               </span>
          )}

        {/*
          
              <ClickAwayListener onClickAway={handleInfoTooltipClose}>
                <div>
                  <HtmlTooltip id="infoTooltip"
                               PopperProps={{
                                   disablePortal: false,
                                   strategy: "fixed",
                                   placement: "bottom-end",
                                   modifiers: 
                                       {
                                           flip: {
                                               // behavior: ['left', 'right', 'top','bottom']
                                               // behavior: ['top']
                                               enabled: false // yes, this works!, need to be using 1.x
                                           },
                                           arrow: {
                                           }
                                       },

                               }}
                               arrow // yes, this works, but make it like we have for the chart tooltip
                               // onClose={handleInfoTooltipClose}
                               open={infoOpen}
                               //disableFocusListener
                               //disableHoverListener
                               //disableTouchListener
                               interactive
                               //disableReactTree={true}
                               title={
                                   <React.Fragment>
                                     <div id="infoDiv">
                                       <div style={{
                                           display: "flex",
                                           justifyContent: "center",
                                           alignItems: "center",
                                           verticalAlign: "center",
                                           height: "56px",
                                           fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
                                           borderBottomColor: "#65676b4d",
                                           borderBottomStyle: "solid",
                                           borderBottomWidth: "1px"
                                       }}>
                                         <span id="infoHeader1Text" style={{
                                             marginTop: "-4px",
                                             marginBottom: "-5px",
                                         }}><Typography style={{
                                             fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                             fontSize: "20px",
                                             fontWeight: 700,
                                             lineHeight: "24px",
                                         }}>About This Map</Typography></span>
                                       </div>

                                       <div id="infoSectionWrapper" style={{
                                           display: "flex",
                                           alignItems: "flex-start",
                                           paddingBottom: "16px",
                                           paddingTop: "14px",
                                           fontSize: "12px"
                                       }}>
                                         <DescriptionIcon style={{
                                             marginRight: "6px",
                                             fontSize: "12px",
                                             verticalAlign: "-3px",
                                             height: "24px",
                                             width: "24px"
                                         }}/>
                                         <div style={{
                                             display: "flex",
                                             flexDirection: "column",
                                             fontSize: "12px",
                                         }}>
                                           <div style={{
                                               fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
                                               fontSize: "15px",
                                               fontWeight: 600,
                                               marginBottom: "4px",
                                               marginTop: "-1px"
                                           }}>Interactive Map</div>

                                           <div style={{
                                               fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                               fontSize: "13px",
                                               fontWeight: 400,
                                               // marginBottom: "-4px",
                                               // marginTop: "-1px",
                                               overflowWrap: "break-word",
                                               textAlign: "left",
                                               wordBreak: "break-word",
                                               color: "#65676b"
                                           }}>All maps are interactive. They provide activity data and link to state and district maps. <b><em>{"Hover over"}</em></b> the <b>region</b> to see activity. <b><em>{"Click on"}</em></b> the <b>region</b> to go to that region.</div>
                                         </div>
                                       </div>


                                       <div id="infoSectionWrapper" style={{
                                           display: "flex",
                                           alignItems: "flex-start",
                                           paddingBottom: "16px",
                                           paddingTop: "14px",
                                           fontSize: "12px"
                                       }}>
                                         <DescriptionIcon style={{
                                             marginRight: "6px",
                                             fontSize: "12px",
                                             verticalAlign: "-3px",
                                             height: "24px",
                                             width: "24px"
                                         }}/>
                                         <div style={{
                                             display: "flex",
                                             flexDirection: "column",
                                             fontSize: "12px",
                                         }}>
                                           <div style={{
                                               fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
                                               fontSize: "15px",
                                               fontWeight: 600,
                                               marginBottom: "4px",
                                               marginTop: "-1px"
                                           }}>Regions</div>

                                           <div style={{
                                               fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                               fontSize: "13px",
                                               fontWeight: 400,
                                               // marginBottom: "-4px",
                                               // marginTop: "-1px",
                                               overflowWrap: "break-word",
                                               textAlign: "left",
                                               wordBreak: "break-word",
                                               color: "#65676b"
                                           }}>
                                             Regions are <b><em style={{color: "#a2c3f8"}}>{"light blue"}</em></b> or <b><em style={{color: "#448cff"}}>{"deeper blue"}</em></b> to reflect general level of activity.{" "}
                                           </div>
                                         </div>
                                       </div>

                                       
                                       <Typography style={{fontSize: "14px"}} color="inherit"></Typography>
                                       Brought <em>{"to you"}</em> by <span style={{color: "blue"}}>{'Lightning'}</span> <u>{'with love'}</u>.{' '}
                                       {" "}<br/><br/>
                                     </div>
                                   </React.Fragment>
                               }>
                    <IconButton aria-label="info" onClick={handleInfoTooltipOpen}>
                      <InfoIcon classes={{root: classes.infoIconRoot}}/>
                    </IconButton>
                  </HtmlTooltip>
                </div>
        </ClickAwayListener>
*/}

        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
}


const getValueMaxNew = (dataset) => {
    log.trace("getValueMax(): dataset =", dataset)
    if(!dataset || dataset.length === 0) {
        log.trace("getValueMax(): returning 100")
        return 100
    }
    let maxValue = 0
    dataset.forEach(d => {
        if(maxValue < d.FBACK_COUNT) maxValue = d.FBACK_COUNT
    })
    // dataset.reduce(maxNumberReducer("FBACK_COUNT"))
    // log.trace("getValueMax(): maxValue =", maxValue)
    return maxValue
}


const getColorNew = (dataset, _maxValue) => {
    log.trace("getColor(): dataset =", dataset)
    log.trace("getColor(): _maxValue =", _maxValue)
    
    const datasetMaxValue = getValueMaxNew(dataset)

    let maxValue
    if(_maxValue > datasetMaxValue) {
        maxValue = _maxValue
    } else {
        maxValue = datasetMaxValue
    }
    log.trace("getColor(): maxValue =", maxValue)
    let color
    if(maxValue === 0) {
        // no data
        color = d3.scaleLinear()
	    .range(
                [
                    "#f2f2f2"
                ]
            )
    } else {
        color = d3.scaleLinear()
	    .range(
                [
                    "#f2f2f2",
                    "#448cff"
                ]
            )
        color.domain([0,maxValue])
    }
    return color
}

const zoomTargetMap = (geo,zoom,target) => {
        log.trace("zoomTargetMap(): target =", target)

        if(!target) return

        // 85121
        // path-74
        // zipCode="85121"
        let zoomPath

        // GEO_SPECIFIC
        if(geo.level === "USCD") {
            // zoomPath = d3.select('[zipCode="85121"]')
            zoomPath = d3.select(`[zipCode="${target.zipCode}"]`)
        } else if(geo.level === "STATE") {
            zoomPath = d3.select(`[uscdCode="${target.uscdCode}"]`)
        } else if(geo.level === "NATIONAL") {
            zoomPath = d3.select(`[stateCode="${target.stateCode}"]`)
        }

        if(!zoomPath || !zoomPath.node()) return // we dont' have all the elements hanging yet

        // eslint-disable-next-line
        const zoomPathSvgBox = zoomPath.node().getBoundingClientRect() // canvas
        const zoomPathBox = JSON.parse(zoomPath.attr("pathBox0"))

        const theG = d3.select("#theG")// we need this g so that mouse is not 
        const theGSvgBox = theG.node().getBoundingClientRect() // canvas
        // const theGPathBox = theG.node().getBBox() // path
        const theGPathBox = JSON.parse(theG.attr("pathBox0"))
	log.trace("zoomTargetMap(): theGSvgBox =", theGSvgBox)
        log.trace("zoomTargetMap(): theGPathBox =", theGPathBox)

        let yScale = 1 / (zoomPathBox.height / theGPathBox.height)
        let xScale = 1 / (zoomPathBox.width / theGPathBox.width)
        let tscale = Math.min(xScale,yScale) * 0.4
        //let tscale = 1.2
        log.trace("zoomTargetMap(): tscale =", tscale)
        log.trace("zoomTargetMap(): d3.zoomIdentity =", d3.zoomIdentity)

        const xOfCenter = theGPathBox.width / 2 - (zoomPathBox.x*tscale - theGPathBox.x) - (zoomPathBox.width / 2)*tscale
        const yOfCenter = theGPathBox.height / 2 - (zoomPathBox.y*tscale - theGPathBox.y) - (zoomPathBox.height / 2)*tscale
        const tOfCenter = {k: tscale, x: xOfCenter, y: yOfCenter} // move path to left edgeX
        let ofCenterTransform = d3.zoomIdentity.translate(tOfCenter.x, tOfCenter.y).scale(tOfCenter.k)

        theG.call(
            zoom.transform,
            ofCenterTransform
        )

    }

const unhighlightMap = (chartSvg) => {
    log.trace("unhighlightMap(): unhighlightMap")
    d3.select(chartSvg.current)
        .select("g")
        .selectAll("path")
        .each((d,i) => {
            const path = d3.select("#path-" + i)
            const oldFill = path.attr("oldFill")
            if(oldFill) path.style("fill",oldFill)

            const theFill = path.attr("theFill")
            path.style("fill", theFill)
        })
}




const highlightMap = (geo,dset,chartSvg,highlights) => {
    log.debug("highlightMap(): highlights =", highlights)
    log.debug("highlightMap(): dset =", dset)
    let maxValue = 0
    highlights.forEach(d => {
        if(maxValue < d.fillValue) maxValue = d.fillValue
    })
    const color = getColorNew(dset,maxValue)
    d3.select(chartSvg.current)
        .select("g")
        .selectAll("path")
        .each((d,i) => {
            log.trace(`hightlightMap(): i=${i}, d=`,d)
            let found
            if(geo.level === "NATIONAL") {
                // we don't have flash* attributes in usa map yet                    
                found = highlights.find(fieldFilter("stateCode", d.properties.stateCode)) 
            } else if (geo.level === "STATE") {
                found = highlights.find(fieldFilter("uscdCode", d.properties.flashUscdCode))
            } else if (geo.level === "USCD") {
                found = highlights.find(fieldFilter("zipCode", d.properties.flashZipCode))
            }
            if(found) {
                log.debug("highlightMap(): found =", found)
                const path = d3.select("#path-" + i)
                const fill = path.style("fill")
                path.attr("oldFill", fill)

                if(found.fillValue) {
                    log.debug("highlightMap(): setting color(found.fillValue), fillValue = ", found.fillValue)
                    path.style("fill", color(found.fillValue))
                } else if(found.fill) {
                    const fill = path.style("fill")
                    path.style("fill", d3.rgb(fill).darker(0.3))
                } else if(found.color && found.color === "green") {
                    path.style("fill", "#7db47b") // nice green, the same
                } else if (found.color && found.color === "red") {
                    path.style("fill", "#fb7676")
                } else if(found.color) {
                    path.style("fill", found.color)
                }
            }
        })
}


const getUscdPropsFromFp = (fp,d) => {
    let props
    props = {
        uscdFP: fp,
        uscdName: `State-${fp}`,
        uscdCode: fp
    }
    return props
}


const getStatePropsFromFp = (fp,d) => {
    let props
    switch (fp) {
    case "06": 
        props = {
            stateFP: fp,
            stateName: "California",
            stateCode: "CA"
        }
        break
    case "04":
        props = {
            stateFP: fp,
            stateName: "Arizona",
            stateCode: "AZ"
        }
        break
    default:
        props = {
            stateFP: d.properties.STATEFP,
            stateName: d.properties.NAME,
            stateCode: d.properties.STUSPS
        }
        break
    }

    return props
}


const getFeatures = (geo, dataset, highlights, nationalFeatures, stateFeatures, uscdFeatures,onPushProperties) => {

//        log.trace("getFeatures(): UscdGeoJson =", UscdGeoJson)
//        log.trace("getFeatures(): ZipGeoJson =", ZipGeoJson)
        log.debug("getFeatures(): nationalFeatures =", nationalFeatures)
        log.debug("getFeatures(): stateFeatures =", stateFeatures)
        log.debug("getFeatures(): uscdFeatures =", uscdFeatures)
        log.debug("getFeatures(): geo =", geo)
        log.trace("getFeatures(): dataset =", dataset)
        log.trace("getFeatures(): highlights =", highlights)
        
        // for example

        let fullFeatures

        switch(geo.level) {
        case "USCD":

            log.trace("getFeatures(): we are in USCD")

            // these zips are currently only subset for ["CA", "AZ", "NY"]
            // see lightning-private/utils/geo/prep/prep.test.js
            //            const zips = _.filter(ZipGeoJson.features, d => {
            const zips = _.filter(uscdFeatures.data.features, d => {
                log.trace("getFeatures(): d=",d)
                log.trace("getFeatures(): looking for geo.stateCode =",geo.stateCode)
                log.trace("getFeatures(): looking for geo.uscdCode =",geo.uscdCode)
                if(d.properties.flashStateCode === geo.stateCode
                   && d.properties.flashUscdCode === geo.uscdCode) {
                    return true
                } else {
                    return false
                }
            })

            log.trace("getFeatures(): zips =", zips)
            
            fullFeatures = _.map(zips, d => {
                return {
                    ...d,
                    properties: {
                        ...d.properties,
                        fp: d.properties.STATEFP,
                        name: d.properties.NAME,
                        code: d.properties.STUSPS,
                        ...getStatePropsFromFp(d.properties.STATEFP,d),
                        ...getUscdPropsFromFp(d.properties.CD116FP,d)
                    }
                }
            })
            onPushProperties(fullFeatures.map(f => f.properties))
            break
        case "STATE":
            //            const uscds = _.filter(UscdGeoJson.features, d => {
            const uscds = _.filter(stateFeatures.data.features, d => {
                //log.debug("getFeatures(): d.properties =", d.properties)
                //log.debug("getFeatures(): geo.stateCode =", geo.stateCode)
                if(d.properties.flashStateCode === geo.stateCode) {
                    if(d.properties.flashStateCode === "CA"
                       && d.properties.flashStateFp !== "06") {
                        log.info("getFeatures(): BUG: d.properties =", d.properties)
                        return false
                    } else if(d.properties.flashStateCode === "TX"
                              && d.properties.flashStateFp !== "48") {
                        log.info("getFeatures(): BUG: d.properties =", d.properties)
                        return  false
                    } else if(d.properties.flashStateCode === "WA"
                              && d.properties.flashStateFp !== "53") {
                        log.info("getFeatures(): BUG: d.properties =", d.properties)
                        return  false
                    } else if(d.properties.flashStateCode === "ID"
                              && d.properties.flashStateFp !== "16") {
                        log.info("getFeatures(): BUG: d.properties =", d.properties)
                        return  false
                    } else if(d.properties.flashStateCode === "IN"
                              && d.properties.flashStateFp !== "18") {
                        log.info("getFeatures(): BUG: d.properties =", d.properties)
                        return  false
                    } else if(d.properties.flashStateCode === "WV"
                              && d.properties.flashStateFp !== "54") {
                        log.info("getFeatures(): BUG: d.properties =", d.properties)
                        return  false
                    } else if(d.properties.flashStateCode === "ME"
                              && d.properties.flashStateFp !== "23") {
                        log.info("getFeatures(): BUG: d.properties =", d.properties)
                        return  false
                    } else if(d.properties.flashStateCode === "NY"
                              && d.properties.flashStateFp !== "36") {
                        log.info("getFeatures(): BUG: d.properties =", d.properties)
                        return  false
                    } else if(d.properties.flashStateCode === "CT"
                              && d.properties.flashStateFp !== "09") {
                        log.info("getFeatures(): BUG: d.properties =", d.properties)
                        return  false
                    }
                    return true
                } else {
                    return false
                }
            })
            
            log.trace("getFeatures(): uscds =", uscds)
            // NEXT: figure out full features here
            
            fullFeatures = _.map(uscds, d => {
                return {
                    ...d,
                    // make it more generic for different level
                    properties: {
                        ...d.properties,
                        fp: d.properties.STATEFP,
                        name: d.properties.NAME,
                        code: d.properties.STUSPS,
                        ...getStatePropsFromFp(d.properties.STATEFP,d),
                        ...getUscdPropsFromFp(d.properties.CD116FP,d)
                    }
                }
            })

            log.trace("getFeatures(): fullFeatures =", fullFeatures)
            onPushProperties(fullFeatures.map(f => f.properties))
            break
        case "NATIONAL": // default to national features, mainly for dev

            /* this will work for national later
            const uscds = _.filter(UsStateGeoJson.features, d => {
                log.trace("getFeatures(): d.properties =", d.properties)
                if(d.properties.STUSPS === geo.stateCode) {
                    return true
                } else {
                    return false
                }
            })
            */
            log.trace("getFeatures(): case NATIONAL")
            //            const states = UsStateGeoJson.features
            const states = nationalFeatures.data.features
            fullFeatures =
                _.map(states, d => {
                    log.trace("getFeatures(): setting the data with d =", d)
                    return {
                        ...d,
                        // make it more generic for different level
                        properties: {
                            // this could be universal for all levels
                            fp: d.properties.STATEFP,
                            name: d.properties.NAME,
                            code: d.properties.STUSPS,
                            ...getStatePropsFromFp(d.properties.STATEFP,d)
                        }
                    }
                })
            onPushProperties(fullFeatures.map(f => f.properties))
            break
        default:
            break
        }
        
        return fullFeatures
    }



const DashMapV5 = ({
    header1, header2,
    geo,
    dataset,
    highlights, zoomTarget,
    onDoubleClick,
    onFilterClick,
    onPushProperties = () =>{}
}) => {

    const appContext = React.useContext(AppContext)
    // log.debug("appContext = ", appContext)

    const chartDiv = React.useRef(null)
    const chartSvg = React.useRef(null)
    const tooltipDiv = React.useRef(null)
    
    const classes = useStyles()
    // eslint-disable-next-line    
    const [order, setOrder] = React.useState('asc')
    // eslint-disable-next-line    
    const [orderBy, setOrderBy] = React.useState('rank')
    const [selected, setSelected] = React.useState([])
    // eslint-disable-next-line    
    const [page, setPage] = React.useState(0)
    // eslint-disable-next-line    
    const [dense, setDense] = React.useState(false)
    const [draw, setDraw] = React.useState(true)
    // eslint-disable-next-line
    const [firstZoom, setFirstZoom] = React.useState(true)
    const [dset, setDSet] = React.useState(dataset)
    // eslint-disable-next-line
    const [isLoadFeatures, setIsLoadFeatures] = React.useState(true)
    const [nationalFeatures, setNationalFeatures] = React.useState(undefined)
    const [stateFeatures, setStateFeatures] = React.useState(undefined)
    const [uscdFeatures, setUscdFeatures] = React.useState(undefined)

    log.trace("body: dataset =", dataset)
    log.trace("body: chartDiv =", chartDiv)
    log.trace("body: chartSvg =", chartSvg)

    // eslint-disable-next-line
    const handleClick = (event, issue) => {
        const selectedIndex = selected.indexOf(issue);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, issue);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };


    const savePathBoxes0 = () => {
        const theG = d3.select("#theG")// we need this g so that mouse is not 
        const theGPathBox = theG.node().getBBox()
        log.trace("saveBox0(): theGPathBox =", theGPathBox)
        const theGPathBox0 = {x: theGPathBox.x, y: theGPathBox.y, width: theGPathBox.width, height: theGPathBox.height}
        theG.attr("pathBox0", JSON.stringify(theGPathBox0))

        const iszooms = d3.selectAll("[iszoom=true]")
        iszooms.attr("pathBox0", (a,b,c,d) => {
            log.trace("saveBox0(): a =", a)
            log.trace("saveBox0(): b =", b)
            log.trace("saveBox0(): c =", c)
            const node = c[b]
            const pathBox = node.getBBox()
            // do stuff here save the boxes
            log.trace("saveBox0(): node =", node)
            log.trace("saveBox0(): pathBox =", pathBox)
            const pathBox0 = {x: pathBox.x, y: pathBox.y, width: pathBox.width, height: pathBox.height}
            return JSON.stringify(pathBox0)
        })

        
    }

    const handleZoom = () => {
        const iszooms = d3.selectAll("[iszoom=true]")
        // const iszooms =  d3.select(chartSvg.current)
        log.trace("handleZoom(): iszooms =", iszooms)
        log.trace("handleZoom(): newScale =", d3.event.transform.k)
        log.trace("handleZoom(): d3.event.transform =", d3.event.transform)

        // stroke has to be before transform, because it relies on the old transform
        // todo: should really have a routine that will create an old trasform object
        // instead of hiding it all in the function
        // it should be modelled based on the d3.event.transform object
        // https://github.com/d3/d3-zoom/blob/v1.8.3/README.md#transform_scale
        iszooms.attr("stroke-width", calcStrokeWidth(iszooms, d3.event.transform.k)) // passing new scale
        iszooms.attr("transform", d3.event.transform)
    }

    const zoom = d3.zoom()
          .scaleExtent([0.2, 10])
          .on("zoom", handleZoom)


    // eslint-disable-next-line
    function interpolateZoom (translate, scale) {
        // var self = this;
        return d3.transition().duration(350).tween("zoom", function () {
            var iTranslate = d3.interpolate(zoom.translate(), translate),
                iScale = d3.interpolate(zoom.scale(), scale);
            return function (t) {
                zoom
                    .scale(iScale(t))
                    .translate(iTranslate(t));
                handleZoom();
            };
        });
    }

//        const drawMap = () => {
    const drawMap = React.useCallback(
        (something) => {
        log.trace("drawMap(): draw =", draw)
        log.trace("drawMap(): setDraw(false)")
        log.debug("drawMap(): geo =",geo)
        setDraw(false) // we've drawn, we'll need another set of this in order to draw again


        // first get map, it will depend on the changed dataset or highlight
        log.trace("drawMap(): calling getFeatures")
            const features = getFeatures(geo, dataset, highlights,
                                         nationalFeatures,
                                         stateFeatures,
                                         uscdFeatures,
                                         onPushProperties
                                        )
        log.trace("drawMap(): features =", features)

        
        // projection
        const svg = d3.select(chartSvg.current).append("g").attr("id", "theG")// we need this g so that mouse is not choppy
 

        if(!features || features.length === 0) {
            const chartDiv = d3.select("#chartDiv")
            // chartDiv.append("div").text("no data yet")
            // chartDiv.text("no data yet")
            chartDiv.insert("div",":first-child")
                .text("These zip codes will be coming online soon...")
                .classed(classes.noDataText, true)
        }
        
        svg.call(zoom)
        //svg.call(zoomWrapper)

        const projection = d3.geoAlbersUsa()

        let pscale = projection.scale()

        if(geo.level === "USCD") {
            log.trace("drawMap(): projection pscale =", pscale)
            projection.scale(pscale * 1000)
        }
        
        const geoPath = d3.geoPath().projection(projection)

        /*
          const color = d3.scaleLinear()
	  .range(
          [
          "#f2f2f2",
          //                    "#448cff"
          ]
          )
          //        color.domain([0,4])
          */
        
        //        svg.selectAll("path.country") // CSS styles defined above
        svg.selectAll() // CSS styles defined above
            .data(features).enter()
            .append("path")
            .attr("id", (d, i) => {
                return "path-" + i
            })
            .attr("iszoom", true)
            .attr("stateCode", d => {
                if(geo.level === "NATIONAL") {
                    return d.properties.code
                } else {
                    return d.properties.flashStateCode
                }
            })
            .attr("uscdCode", d => d.properties.flashUscdCode)
            .attr("zipCode", d => d.properties.flashZipCode)
        // begin class 
	    .attr("fill","#f2f2f2")
            .attr("stroke", "black")
    	    .attr("stroke-width", 0.3)
        // end class
            .attr("iszoom", true)
            .attr("d", geoPath)
        //            .style("fill", (d,i) => {
        //                return color(0)
        //            })
        /*
          .style("stroke-width", (d, i) => {
          if(geoLevel === "USCD")
          return 20
          else if (geoLevel === "state")
          return 0.15
          else 
          return 0.5
          })
        */

        //
        // Transform begin
        //
        const svgCurr = d3.select(chartSvg.current)
        const svgWidth = svgCurr.node().getBoundingClientRect().width
        const svgHeight = svgCurr.node().getBoundingClientRect().height

        const mapCurr = svgCurr.select("g")
	log.trace("body: mapCurr =", mapCurr)
        const mapWidth = mapCurr.node().getBoundingClientRect().width
        const mapHeight = mapCurr.node().getBoundingClientRect().height

	log.trace("drawMap: svgWidth =", svgWidth)
	log.trace("drawMap: svgHeight =", svgHeight)
        
	log.trace("drawMap: mapWidth =", mapWidth)
	log.trace("drawMap: mapHeight =", mapHeight)
        
        const chart = d3.select("#chartSvg")
        const svgBox = chart.node().getBoundingClientRect() // canvas
        const pathBox = chart.node().getBBox() // path
	log.trace("drawMap(): chartBox =", svgBox)
	log.trace("drawMap(): pathBox =", pathBox)

        let yScale = 1 / (pathBox.height / svgBox.height)
        let xScale = 1 / (pathBox.width / svgBox.width)

        log.trace("drawMap(): yScale =", yScale)
        log.trace("drawMap(): xScale =", xScale)
        
        let tscale = Math.min(xScale,yScale) * 0.95

        let tx = (svgBox.width - pathBox.width * tscale)/2 - pathBox.x * tscale
        let ty = (svgBox.height/2 - pathBox.height/2 * tscale) - pathBox.y * tscale

        // TODO: we should create a transform object here and pass it instead of a string
        // like transformString
        const transformString = `translate(${tx},${ty}) scale(${tscale})`
        svg.attr("transform", transformString)

        const iszooms = d3.selectAll("[iszoom=true]")
        // szooms.attr("stroke-width", calcStrokeWidth(iszooms, tscale))
        
        try {
            iszooms.attr("stroke-width", calcStrokeWidth(iszooms, tscale))
        } catch (e) {
            log.info("getFeatures(): BUG: can't calcStrokeWidth()")
            iszooms.attr("stroke-width", 0.3)
        }

        
        savePathBoxes0() // saving original path boxes for g and district paths
        
        // set proper stroke width
        // const iszooms = d3.selectAll("[iszoom=true]")

        /*
        // begin stroke width 
	const oldStrokeWidth = iszooms.attr("stroke-width")
	const oldTransform = iszooms.attr("transform")
	let newStrokeWidth = oldStrokeWidth
        newStrokeWidth = oldStrokeWidth * (1/tscale)
        iszooms.attr("stroke-width", newStrokeWidth)
        // end stroke width 
        */

        // svg.selectAll("[iszoom=true]").attr("stroke-width", 10)
        
        } // drawMap
        ,[classes,dataset,draw,geo,highlights,zoom,nationalFeatures,stateFeatures,uscdFeatures,onPushProperties])
    
    const calcStrokeWidth = (paths,  newScale, _oldScale) => {
        let oldStrokeWidth = paths.attr("stroke-width")

//        try {
//            oldStrokeWidth = paths.attr("stroke-width")
//        } catch (e) {
//            oldStrokeWidth = 0.3
//        }

        
	const oldTransform = paths.attr("transform")

        let oldScale
        if(_oldScale) {
            oldScale = _oldScale
        } else if(oldTransform) {
	    oldScale = oldTransform.split("scale(")[1].replace(")","")
        } else {
            oldScale = 1
        }

	let newStrokeWidth = oldStrokeWidth * (oldScale/newScale)
        return newStrokeWidth
    }

    const updateMap = React.useCallback(
        (dataset) => {
            log.debug("updateMap(): dataset =", dataset)
            if(!dataset || dataset === []) return

            const handlePathMouseOver = (d,i) => {
                log.trace(`handlePathMouseOver(): dataset =`, dataset)
                log.trace(`handlePathMouseOver(): d=`, d)

                const path = d3.select("#path-" + i)
                const fill = path.style("fill")
                path.style("fill", d3.rgb(fill).darker(0.3))
                
                const tooltip = d3.select("#tooltipDiv")
                
                //log.trace(`handlePathMouseOver(): path.node().datum().properties =`, path.datum().properties)

                /*
                const fullStats = _.filter(dataset, d => {
                    log.trace(`handlePathMouseOver(): filtering d =`, d)
                    // TODO: find by txt, not uuid yet
                    if(geo.level === "national") {
                        return (d.user)
                            && (d.user.geo)
                            && (d.user.geo.state)
                            && (d.user.geo.state.name === path.datum().properties.name)
                    } else if(geo.level === "state") {
                        log.trace(`updateMap(): properties =`, path.datum().properties)
                        return (d.user)
                            && (d.user.geo)
                            && (d.user.geo.uscd)
                            && (d.user.geo.uscd.code === path.datum().properties.uscdCode)
                    } else if (geo.level === "USCD") {
                        log.trace(`updateMap(): fullStats, properties =`, path.datum().properties)
                        log.trace(`updateMap(): fullStats, path Zip code  =`, path.datum().properties.ZCTA5CE10)
                        log.trace(`updateMap(): fullStats, d user zip code  =`, d.user.geo.zip.code)
                        return (d.user)
                            && (d.user.geo)
                            && (d.user.geo.zip)
                            && (d.user.geo.zip.code === path.datum().properties.ZCTA5CE10)
                    }
                    return []
                })
                log.trace(`updateMap(): fullStats =`, fullStats) // TODO: this is what updates the feedback count, etc.
                */

                // we need to remove the state clause, but we can do that later
                // set name
                const stateName = tooltip.select("#stateName")

                // TODO: the "national" is special case, we need to prep the us_states files so that they have
                // proper "properties.flash*"
                // instead
                // code: "MI"
                // fp: "26"
                // name: "Michigan"
                // stateCode: "MI"
                // stateFP: "26"
                // stateName: "Michigan"
                if(geo.level === "NATIONAL") {
                    log.trace("getFeatures(): path.datum().properties =", path.datum().properties)
                    stateName.text(path.datum().properties.name)
                } else {
                    stateName.text(path.datum().properties.flashStateName)
                }

                const stateFp = tooltip.select("#stateFp")
                if(geo.level === "NATIONAL") {
                    stateFp.text(path.datum().properties.fp)
                } else {
                    stateFp.text(path.datum().properties.flashStateFp)
                }

                const stateCode = tooltip.select("#stateCode")
                if(geo.level === "NATIONAL") {
                    // stateCode.text(path.datum().properties.stateCode) // path name (currently state name)
                    stateCode
                        .select("#stateCodeVal")
                        .text(path.datum().properties.name)
                        //.text("I'm here")
                } else {
                    // stateCode.text(path.datum().properties.flashStateCode) // path name (currently state name)
                    stateCode
                        .select("#stateCodeVal")
                        .text(path.datum().properties.flashStateName)
                }

                const uscdCode = tooltip.select("#uscdCode")

                
                log.trace("properties = ", path.datum().properties)
                // const uscdCodeVal = path.datum().properties.flashUscdCode

                const uscdCodeVal = `${path.datum().properties.flashStateCode}-${path.datum().properties.flashUscdCode}`
                
                uscdCode
                    .select("#uscdCodeVal")
                    .text(uscdCodeVal)

                const zipCode = tooltip.select("#zipCode")
                if(geo.level === "USCD" ) {
                    zipCode
                        .select("#zipCodeVal")
                        .text(path.datum().properties.flashZipCode)
                } else {
                    zipCode.style("display", "none")
                }
                
                // set count
                const count = tooltip.select("#count")

                //const subCountSum = getSubCountSum(fullStats)

                log.trace(`handlePathMouseOver(): dataset =`, dataset)
                log.trace(`handlePathMouseOver(): d =`, d)

                const data = accessData(d)
                log.trace(`handlePathMouseOver(): data =`, data)
                
                if(data && data.FBACK_COUNT) {
                    count.text(data.FBACK_COUNT)
                } else {
                    count.text(0)
                }
                
                tooltip
                    .style("left", `${d3.event.pageX}px`)
                    .style("top", `${d3.event.pageY}px`)
                    .style("opacity", "1")
                
            }

            const handlePathMouseOut = (d,i) => {
                // log.trace(`handlePathMouseOut(): i=${i}, d=`,d)
                const path = d3.select("#path-" + i)
                //              .style("fill-opacity", "1")
                //const fill = path.style("fill")
                //path.style("fill", d3.rgb(fill).brighter(0.3))
                // path.style("fill", "black")
                const oldFill = path.attr("theFill")
                path.style("fill", oldFill)
                // log.trace(`handlePathMouseOut(): fill=`, fill)
                d3.select("#tooltipDiv")
                    .style("opacity", "0")
            }


            /*
            const getValueMax = () => {
                log.trace("getValueMax(): dataset =", dataset)
                if(!dataset || dataset.length === 0) {
                    log.trace("getValueMax(): returning 100")
                    return 100
                }
                let maxValue = 0
                dataset.forEach(d => {
                    if(maxValue < d.FBACK_COUNT) maxValue = d.FBACK_COUNT
                })
                // dataset.reduce(maxNumberReducer("FBACK_COUNT"))
                // log.trace("getValueMax(): maxValue =", maxValue)
                return maxValue
            }
            */

            // let color = getColor(dataset)
            let color = getColorNew(dataset)
            
            /*
            let color
            if(getValueMax(dataset) === 0) {
                // no data
                color = d3.scaleLinear()
	            .range(
                        [
                            "#f2f2f2"
                        ]
                    )
            } else {
                color = d3.scaleLinear()
	            .range(
                        [
                            "#f2f2f2",
                            "#448cff"
                        ]
                    )
                color.domain([0,getValueMax(dataset)])
            }
            */

            // get the data for this d from teh dataset
            // based on the geoLevel
            const accessData = (d) => {
                if(geo.level === "NATIONAL") {
                    // search the dataset for all the
                    // state level data, then access this specific
                    // item based on the properties
                    // NEXT:
                    log.trace("accessData(): dataset =", dataset)
                    const stateData = dataset.filter(fieldFilter("geo.level", "STATE"))
                    log.trace("accessData(): stateData =", stateData)
                    log.trace("accessData(): d.properties.stateCode =", d.properties.stateCode)
                    const thisData = stateData.filter(data => {
                        return data.user.geo.state.code === d.properties.stateCode
                    })
                    if(thisData[0]) log.trace("accessData(): thisData[0] =", thisData[0])
                    return thisData[0]
                } else if(geo.level === "STATE") {
                    const uscdData = dataset.filter(fieldFilter("geo.level", "USCD"))
                    log.trace("accessData(): uscdData =", uscdData)
                    log.trace("accessData(): d.properties.stateCode =", d.properties.stateCode)
                    log.trace("accessData(): d.properties.uscdCode =", d.properties.uscdCode)
                    const thisData = uscdData.filter(data => {
                        log.trace("accessData(): data.user.geo.state.code =", data.user.geo.state.code)
                        log.trace("accessData(): data.user.geo.uscd.code =", data.user.geo.uscd.code)
                        return (data.user.geo.uscd.code === d.properties.uscdCode
                                && data.user.geo.state.code === d.properties.stateCode)
                    })
                    if(thisData[0]) log.trace("accessData(): thisData[0] =", thisData[0])
                    return thisData[0]
                } else if(geo.level === "USCD") {
                    const zipData = dataset.filter(fieldFilter("geo.level", "ZIP"))
                    log.trace("accessData(): zipData =", zipData)
                    log.trace("accessData(): d.properties.flashZipCode =", d.properties.flashZipCode)
                    const thisData = zipData.filter(data => {
                        return data.user.geo.zip.code === d.properties.flashZipCode
                    })
                    if(thisData[0]) log.trace("accessData(): thisData[0] =", thisData[0])
                    return thisData[0]
                } else {
                    return undefined
                }
            }
            
            const getFill = (d) => {
                const data = accessData(d)
                if(data) {
                    log.trace("getFill(): color(data.FBACK_COUNT) =", color(data.FBACK_COUNT))
                    return color(data.FBACK_COUNT)
                } else {
                    return color(0)
                }
            }

            
            d3.select(chartSvg.current)
                .select("g")
                .selectAll("path")
                .style("fill", d => getFill(d))
                .attr("theFill", d => getFill(d))
                .on("mouseover", (d,i) => {
                    handlePathMouseOver(d,i)
                })
                .on("mouseout", (d,i) => {
                    handlePathMouseOut(d,i)
                })
                .on("dblclick", (d,i) => {
                    // let nextLevel
                    // if(geoLevel === "national") {
                    //   nextLevel = "state"
                    // }
                    if(geo.level !== "USCD") {
                        onDoubleClick("whateverfornow", d, i)
                    }
                })
                .on("click", (d,i) => {
                    // let nextLevel
                    // if(geoLevel === "national") {
                    //   nextLevel = "state"
                    // }
                    if(geo.level !== "USCD") {
                        onDoubleClick("whateverfornow", d, i)
                    }
                })

        }
        ,[geo,onDoubleClick])

    // TODO: weird dependency warnings here
    React.useEffect(() => {
        setDSet(dataset)
        if(!draw) {
            log.trace("useEffect2(): calling updateMap(dataset)")
            updateMap(dataset)
        }
    },[dataset,draw,updateMap])


    React.useEffect(() => {
        log.trace("useEffect3(): zoomTarget changes = ", zoomTarget)
        if(zoomTarget !== {}) {
            zoomTargetMap(geo, zoom, zoomTarget)
        }
    },[geo,zoom,zoomTarget])
    

    // useEffect1
    React.useEffect(() => {
        log.debug("useEffect1(): geo = ", geo)
        // log.debug("useEffect1(): nationalFeatures = ", nationalFeatures)
        if(geo.level === "NATIONAL" && nationalFeatures !== undefined) {
            if(draw) {
                log.debug("useEffect1(): ready with nationalFeatures, draw, nationalFeatures =", nationalFeatures)
                setDraw(false)
                drawMap()
            }
        } else if(geo.level === "STATE" && stateFeatures !== undefined) {
            if(draw) {
                log.debug("useEffect1(): ready with stateFeatures, draw, stateFeatures =", stateFeatures)
                setDraw(false)
                drawMap()
            }
        } else if(geo.level === "USCD" && uscdFeatures !== undefined) {
            if(draw) {
                log.debug("useEffect1(): ready with uscdFeatures, draw, uscdFeatures =", uscdFeatures)
                setDraw(false)
                drawMap()
            }
        }
           
        return () => {
            // when data updates, do this
            // before chart unmounts, do this
        }
    }, [draw,geo,nationalFeatures,stateFeatures,uscdFeatures,drawMap])

    React.useEffect(() => {
        if(highlights && highlights.length > 0) {
            highlightMap(geo,dset,chartSvg,highlights)
        } else {
            unhighlightMap(chartSvg)
        }
    }, [geo,dset,highlights])


    /*
    async function fetchGeoJson(geo) {

        log.debug("fetchGeoJson(): geo =", geo)
        //log.debug("fetchGeoJson(): user =", user)

        return
        
        log.debug("fetchGeoJson(): geo =", geo)
        let objectName
        if(geo.level === "NATIONAL") {
            // objectName = "us_state.json"
            objectName = "us_state.json.gz"
        } else if(geo.level === "STATE") {
            //objectName = "us_cd_500k-0001-mini-rich.json"
            objectName = "us_cd_500k-0001-mini-rich.json.gz"
        } else if(geo.level == "USCD") {
            //objectName = "us_zcta510_500k-0001-mini-rich-subset.json"
            objectName = "us_zcta510_500k-0001-mini-rich-subset.json.gz"
        } else {
            log.debug("fetchGeoJson(): ERROR: did have valid geo =", geo)
        }
        
        const instance = axios.create({
            baseURL: "https://storage.googleapis.com/lightning-flash-public/",
            withCredentials: false,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods':'GET',
            }
        });

        try {
            log.debug("fetchGeoJson(): geo.level =", geo.level)
                const result = await instance.get(objectName)
                log.debug("fetchGeoJson(): result =", result)
            
            
            if(geo.level === "NATIONAL") {
                //log.debug("fetchGeoJson(): setting national features to =", result.data)
                //                setNationalFeatures(
                //                    JSON.parse(pako.inflate([...result.data], { to: 'string' }))
                //                )
                //setNationalFeatures(JSON.parse(data))

                log.debug("NATIONAL json =", result.data)
                setNationalFeatures(result.data)
                
            } else if(geo.level === "STATE") {
                //                setStateFeatures(
                //                    JSON.parse(pako.inflate([...result.data], { to: 'string' }))
                //                )
                //setStateFeatures(JSON.parse(data))
                log.debug("STATE json =", result.data)
                setStateFeatures(result.data)
            } else if(geo.level == "USCD") {
                //                setUscdFeatures(
                //                    JSON.parse(pako.inflate([...result.data], { to: 'string' }))
                //                )
                //setUscdFeatures(JSON.parse(data))
                log.debug("USCD json =", result.data)
                setUscdFeatures(result.data)
            } else {
                log.debug("useEffect4(): ERROR: did have valid geo =", geo)
            }
            setIsLoadFeatures(false)

        } catch (error) {
            log.debug("fetchGeoJson(): error =", error)
        }
    }
    */
    /*
    // Effect4
    React.useEffect(() => {
        log.debug("useEffect4(): start loading...")

        if(isLoadFeatures) {
            fetchGeoJson({level: "NATIONAL"})

            fetchGeoJson({level: "STATE"})

            fetchGeoJson({level: "USCD"})

            setIsLoadFeatures(false)
        }
        
    }, [isLoadFeatures])
    */


    //Effect5
    React.useEffect(() => {
        log.debug("useEffect5(): setting features...")
        setNationalFeatures(appContext.getJson("NATIONAL"))
        setStateFeatures(appContext.getJson("STATE"))
        setUscdFeatures(appContext.getJson("USCD"))
    }, [appContext])
    
    return (
        <div className={classes.root}>
          <Paper className={classes.paper}>
            <EnhancedTableToolbar
              header1={header1}
              header2={header2}
              numSelected={selected.length} onFilterClick={onFilterClick}/>
            <div ref={chartDiv} id="chartDiv" className={classes.chartDiv}>

              <div ref={tooltipDiv} id="tooltipDiv" className={classes.tooltipDiv}>

                { false &&
                  <div style={{display: "flex", justifyContent: "space-between"}}>
                    <div>state name:&nbsp;&nbsp;</div>
                    <div id="stateName">stateName</div>
                  </div>
                }
                
                {/*
                   <div style={{display: "flex", justifyContent: "space-between"}}>
                   <div>state fp:</div>
                   <div id="stateFp">stateFp</div>
                   </div>
                 */}

                { false &&
                  <div style={{display: "flex", justifyContent: "space-between"}}>
                    <div>state code:</div>
                    <div id="stateCode">stateCode</div>
                  </div>
                }

                { false &&
                  <div id="uscdCode" style={{display: "flex", justifyContent: "space-between"}}>
                    <div>uscd code:</div>
                    <div id="uscdCodeVal">uscdCode</div>
                  </div>
                }

                { geo.level === "USCD" &&
                  <div id="zipCode" style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography className={classes.tooltipItemName} variant="h6" id="tooltipItemName1">
                      Zip Code:
                    </Typography>

                  <Typography className={classes.tooltipItemVal} variant="h6" id="tooltipItemVal1">
                    <div id="zipCodeVal" className={classes.tooltipItemVal}>zipCode</div>
                  </Typography>
                  </div>
                }


                { geo.level === "STATE" &&
                  <div id="uscdCode" style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography className={classes.tooltipItemName} variant="h6" id="tooltipItemName2">
                      District:
                    </Typography>

                    <Typography className={classes.tooltipItemVal} variant="h6" id="tooltipItemVal2">
                      <div id="uscdCodeVal" className={classes.tooltipItemVal}>uscdCode</div>
                    </Typography>
                  </div>
                }


                { geo.level === "NATIONAL" &&
                  <div id="stateCode" style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography className={classes.tooltipItemName} variant="h6" id="tooltipItemName2">
                      State:
                    </Typography>

                    <Typography className={classes.tooltipItemVal} variant="h6" id="tooltipItemVal2">
                      <div id="stateCodeVal" className={classes.tooltipItemVal}>stateName</div>
                    </Typography>
                  </div>
                }
                
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                  <Typography className={classes.tooltipItemName} variant="h6" id="tooltipItemName1">
                    Feedback Count:
                  </Typography>
                  <Typography className={classes.tooltipItemVal} variant="h6" id="tooltipItemVal1">
                     <div className={classes.tooltipItemVal} id="count">count</div>
                  </Typography>
                  
                </div>
              </div>
              {geo.level === "NATIONAL" && nationalFeatures === undefined &&
               <div className={classes.loadingMessage} style={{marginLeft: "16px"}}>Loading National Map...</div>
              }
              {geo.level === "STATE" && stateFeatures === undefined &&
               <div className={classes.loadingMessage} style={{marginLeft: "16px"}}>Loading State Map...</div>
              }
              {geo.level === "USCD" && uscdFeatures === undefined &&
               <div className={classes.loadingMessage} style={{marginLeft: "16px"}}>Loading US Congressional District Map...</div>
              }
              <svg ref={chartSvg} id="chartSvg" className={classes.chartSvg}>
              </svg>
            </div>
          </Paper>
        </div>
    )
}

export default DashMapV5








